export const servicesExample = [
  {
    "type*": "delivery",
    name: "Erasmus University Rotterdam",
    "street*": "Burgemeester Oudlaan 50",
    city: "Rotterdam",
    "postal_code*": "3062 PA",
    "country_code*": "NL",
    lat: null,
    long: null,
    duration: "8",
    from: "08:00",
    to: "18:00",
    email: null,
    phone: "+31 10 408 1111",
    priority: "Yes",
    pod_signature: "Yes",
    pod_age: null,
    pod_photo: "Yes",
    delivery_note: "Report at the desk upon arrival",
    vehicle_tags: "Electric; Refrigerator",
    driver_tags: "",
    unit_count: "5",
    unit_weight: "1",
    unit_volume: "2",
    unit_id: "MED3493",
    unit_note: "Keep the box upright",
    tracking_id: null
  },
  {
    "type*": "pickup",
    name: "Sumo Oriental",
    "street*": "Kortekade 1-3",
    city: "Rotterdam",
    "postal_code*": "3062 GK",
    "country_code*": "NL",
    lat: null,
    long: null,
    duration: "2",
    from: "08:00",
    to: "10:00",
    email: null,
    phone: "+31 10 307 2299",
    priority: null,
    pod_signature: "Yes",
    pod_age: null,
    pod_photo: null,
    delivery_note: "Use the back door",
    vehicle_tags: "",
    driver_tags: "Category BC",
    unit_count: "1",
    unit_weight: null,
    unit_volume: null,
    unit_id: null,
    unit_note: null,
    tracking_id: null
  },
  {
    "type*": "delivery",
    name: "Peter de Vries",
    "street*": "Westplein 12",
    city: "Rotterdam",
    "postal_code*": "3016 BM",
    "country_code*": "NL",
    lat: null,
    long: null,
    duration: "2",
    from: "10:00",
    to: "12:00",
    email: "info@storegear.nl",
    phone: "+31 10 311 1002",
    priority: null,
    pod_signature: "Yes",
    pod_age: null,
    pod_photo: null,
    delivery_note: null,
    vehicle_tags: "Refrigerator",
    driver_tags: "",
    unit_count: "1",
    unit_weight: 2,
    unit_volume: null,
    unit_id: null,
    unit_note: null,
    tracking_id: null
  },
  {
    "type*": "delivery",
    name: "Croissanterie de Snor",
    "street*": "Bergpolderplein 10",
    city: "Rotterdam",
    "postal_code*": "3051 GA",
    "country_code*": "NL",
    lat: null,
    long: null,
    duration: "4",
    from: "08:00",
    to: "18:00",
    email: null,
    phone: "+31 10 461 2223",
    priority: "Yes",
    pod_signature: null,
    pod_age: "Yes",
    pod_photo: null,
    delivery_note: null,
    vehicle_tags: "",
    driver_tags: "Category C; Category A",
    unit_count: "2",
    unit_weight: null,
    unit_volume: 3,
    unit_id: "Wine box",
    unit_note: "Fragile, watch out",
    tracking_id: null
  }
];

export const driversExample = [
  {
    "first_name*": "Alice",
    "last_name*": "Lucas",
    "email*": "alice@yourorganization.com",
    mobile_number: "+12132627525",
    driver_tags: ""
  },
  {
    "first_name*": "Soraya",
    "last_name*": "Gomez",
    "email*": "soraya.gomez@gmail.com",
    mobile_number: "+31681423345",
    driver_tags: "Category C"
  },
  {
    "first_name*": "Patrick",
    "last_name*": "Daniel",
    "email*": "patrick@yourorganization.com",
    mobile_number: "+33678552343",
    driver_tags: ""
  },
  {
    "first_name*": "John",
    "last_name*": "Schwartz",
    "email*": "john.schwartz@gmail.com",
    mobile_number: "+971547726543",
    driver_tags: "Category BC"
  }
];

export const vehiclesExample = [
  {
    "license_plate*": "64-RXL-2",
    // "type*": "Car or Truck",
    max_units: "-",
    max_weight: "20",
    max_volume: "-",
    vehicle_tags: "Refrigerator"
  },
  {
    "license_plate*": "L-804U",
    // "type*": "Bicycle",
    max_units: "120",
    max_weight: "80",
    max_volume: "25",
    vehicle_tags: "-"
  },
  {
    "license_plate*": "1ABC123",
    // "type*": "Car or Truck",
    max_units: "-",
    max_weight: "-",
    max_volume: "30",
    vehicle_tags: "Electric"
  },
  {
    "license_plate*": "BQ-670-QB",
    // "type*": "Car or Truck",
    max_units: "200",
    max_weight: "50",
    max_volume: "-",
    vehicle_tags: "-"
  }
];
